import  RichText, { summariseRichText } from './rich-text'
export { summariseRichText } from './rich-text'
export default RichText
